<script setup lang="ts">
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import Icon from '@/components/Icon.vue'
import { callState, setMic, setDeafen, leaveCall } from '@/lib/call'
import { useFloor } from '@/stores/floor'
import { useCapture } from '@/stores/capture'

const route = useRoute()
const router = useRouter()
const floor = useFloor()
const capture = useCapture()

// Shown when you're in a call but not looking at that room (ambient persistence).
const show = computed(() => {
  const slug = callState.roomSlug
  const viewingThis = route.name === 'room' && route.params.slug === slug
  return callState.connected && !!slug && !viewingThis
})

// The recording indicator must follow you away from the room (§11).
const recording = computed(() => {
  const id = callState.roomSlug ? floor.slugToRoom[callState.roomSlug] : ''
  return !!id && capture.recording(id)
})

function returnToRoom() { if (callState.roomSlug) void router.push(`/room/${callState.roomSlug}`) }
function leave() { void leaveCall(); void floor.hangUp(); void router.push('/floor') }
</script>

<template>
  <div v-if="show" class="mini-call">
    <button class="mini-call__return" title="Return to room" @click="returnToRoom">
      <span class="mini-call__pulse" />
      <span class="mini-call__txt"><b>{{ callState.roomName }}<span v-if="recording" class="mini-call__rec">● REC</span></b><span>{{ callState.count }} on the call · tap to return</span></span>
    </button>
    <button class="mini-call__icon" :class="{ on: callState.mic }" :title="callState.mic ? 'Mute' : 'Unmute'" @click="setMic(!callState.mic)">
      <Icon :name="callState.mic ? 'mic' : 'micOff'" :size="18" />
    </button>
    <button class="mini-call__icon" :class="{ on: !callState.deafen }" :title="callState.deafen ? 'Sound is off — click to listen' : 'Mute sound output'" @click="setDeafen(!callState.deafen)">
      <Icon :name="callState.deafen ? 'soundOff' : 'sound'" :size="18" />
    </button>
    <button class="mini-call__leave" title="Leave the call" @click="leave"><Icon name="leave" :size="18" /></button>
  </div>
</template>

<style scoped>
.mini-call__rec {
  margin-left: 8px; font-size: 10px; font-weight: 700; letter-spacing: 0.06em;
  color: #ff6369; animation: mini-rec 1.4s ease-in-out infinite;
}
@keyframes mini-rec {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.35; }
}
</style>
